import { Link } from "react-router-dom";
import { studio } from "@/data/site";
import { visibleApps } from "@/data/apps";

const Col = ({ title, children }) => (
  <div>
    <h4 className="label mb-5">{title}</h4>
    <ul className="space-y-3">{children}</ul>
  </div>
);

const Row = ({ to, children, testId, external }) => (
  <li>
    {external ? (
      <a
        href={to}
        data-testid={testId}
        className="link-underline text-sm text-gray-400 transition-colors duration-300 hover:text-white"
      >
        {children}
      </a>
    ) : (
      <Link
        to={to}
        data-testid={testId}
        className="link-underline text-sm text-gray-400 transition-colors duration-300 hover:text-white"
      >
        {children}
      </Link>
    )}
  </li>
);

export const Footer = () => (
  <footer
    className="grain relative overflow-hidden pt-16 sm:pt-24"
    style={{ background: "var(--ink-2)", borderTop: "1px solid var(--line)" }}
  >
    <div className="shell">
      <div className="grid gap-12 pb-14 sm:gap-14 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Link to="/" className="font-display text-2xl font-extrabold tracking-tight text-white">
            {studio.displayName}
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-gray-400">{studio.tagline}</p>
          <a
            href={`mailto:${studio.supportEmail}`}
            data-testid="footer-support-email"
            className="mt-6 inline-block font-mono-x text-sm"
            style={{ color: "var(--accent)" }}
          >
            {studio.supportEmail}
          </a>
          <p className="mt-1 font-mono-x text-[10px] uppercase tracking-[0.16em] text-gray-600">
            AuraHealth customer service
          </p>
        </div>

        <Col title="Apps">
          {visibleApps.map((a) => (
            <Row key={a.id} to={`/apps/${a.slug}`} testId={`footer-app-${a.slug}`}>
              {a.name}
              {a.status === "coming-soon" && (
                <span className="ml-2 text-xs text-gray-600">soon</span>
              )}
            </Row>
          ))}
          <Row to="/apps" testId="footer-all-apps">
            All apps
          </Row>
        </Col>

        <Col title="Support">
          <Row to="/support" testId="footer-support-link">
            Support &amp; contact
          </Row>
          <Row to="/support#faq" testId="footer-faq-link">
            FAQ
          </Row>
          <Row to="/sources" testId="footer-sources-link">
            Sources &amp; references
          </Row>
        </Col>

        <Col title="Legal">
          <Row to="/privacy" testId="legal-privacy-policy-link">
            Privacy Policy
          </Row>
          <Row to="/terms" testId="legal-terms-link">
            Terms of Use
          </Row>
          <Row to="/sources#disclaimer" testId="legal-disclaimer-link">
            Health disclaimer
          </Row>
        </Col>
      </div>

      <div
        className="flex flex-col gap-3 py-8 text-xs text-gray-500 sm:flex-row sm:items-center sm:justify-between"
        style={{ borderTop: "1px solid var(--line)" }}
      >
        <p>
          © {new Date().getFullYear()} {studio.legalName}. All rights reserved.
        </p>
        <p className="font-mono-x">{studio.domain}</p>
      </div>
    </div>
  </footer>
);
